import ImpersonateUser from "./ImpersonateUser";

export default ImpersonateUser;